export default __webpack_public_path__ + "static/B0005-e3132dd55a8d12c0849114f4e1e6aaa8.png";